// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1nG3-","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__UTH4z"};